module.exports = __webpack_public_path__ + "e52cdb9574.png";